import {CompetitionViewModel} from "../../../domain/common/competition/models/competition-view-model";
import {BaseHeaderViewModel} from "./base-header.view-model";
import {COMPETITION_CONTAINER} from "../../../containers/competition-container/competition-container.consts";
import {BaseHeaderListItemViewModel} from "../modules/mega-header/models/base-header-list-item-view.model";
import {CompetitionDomainModel} from "../../../domain/common/competition/models/competition-domain-model";
import {APP, SPORT_TYPES} from "../../../core/app/consts";
import {BolaoLinkModel} from "../../../containers/bolao-container/models/bolao-link-model";
import {AppTerms} from "../../../core/app/app-terms";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {CompetitionLinkModel} from "../../../containers/competition-container/models/competition.link-model";
import {CompetitionStandingsPageLinkModel} from "../../../containers/competition-container/pages/standings-page/models/competition-standings-page.link-model";
import {CompetitionBracketsPageLinkModel} from "../../../containers/competition-container/pages/brackets-page/models/competition-brackets-page.link-model";
import {CompetitionStatsPageLinkModel} from "../../../containers/competition-container/pages/stats-page/models/competition-stats-page.link-model";

export class CompetitionHeaderViewModel extends BaseHeaderViewModel {
  entity: CompetitionDomainModel;

  constructor(terms: AppTerms, navigationManager: NavigationManager, entity: EntityViewModel, isSmallView: Boolean, minFollowValue: Number) {
    super(terms, navigationManager, entity, isSmallView);
    this.entity = entity;
    this.minFollowValue = minFollowValue;
  }

  get entityVM(): CompetitionViewModel {
    return new CompetitionViewModel(this.entity, this.minFollowValue);
  }

  get AnalyticsEntityType(): APP.ANALYTICS.ENTITY_DISPLAY_TYPES {
    return APP.ANALYTICS.ENTITY_DISPLAY_TYPES[CompetitionViewModel.name]
  }

  get links() {
    const competitionScoresLinkModel: CompetitionLinkModel = new CompetitionLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);
    competitionScoresLinkModel.settings.resetState = true;

    const competitionStandingsLinkModel: CompetitionStandingsPageLinkModel = new CompetitionStandingsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, COMPETITION_CONTAINER.FILTERS.standings, null, this.entity.isFollow);
    const competitionBracketsLinkModel: CompetitionBracketsPageLinkModel = new CompetitionBracketsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);
    const competitionStatsLinkModel: CompetitionStatsPageLinkModel = new CompetitionStatsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);
    const competitionBolaoLinkModel = new BolaoLinkModel();

    const links: Array<BaseHeaderListItemViewModel> = [];

    const scoresLinkTab: BaseHeaderListItemViewModel = new BaseHeaderListItemViewModel({
      name: this.terms.WEB_ENTITY_PREVIEW,
      linkModel: competitionScoresLinkModel,
      visible: true,
      active: this.isScoresScreenActive,
      index: 0
    });

    const standingsLinkTab: BaseHeaderListItemViewModel = new BaseHeaderListItemViewModel({
      name: this.standingsTabTitleName(this.entity),
      linkModel: competitionStandingsLinkModel,
      isLive: this.entity.hasLiveStandings,
      active: this.isStandingsTabActive,
      index: 1,
      isStandings: true
    });

    const bracketsLinkTab: BaseHeaderListItemViewModel = new BaseHeaderListItemViewModel({
      name: this.bracketsName,
      linkModel: competitionBracketsLinkModel,
      active: this.isBracketsTabActive,
      index: 2,
      isBrackets: true
    });

    const statsLinkTab: BaseHeaderListItemViewModel = new BaseHeaderListItemViewModel({
      name: this.terms.STATS,
      linkModel: competitionStatsLinkModel,
      active: this.isStatsTabActive,
      index: 3,
      isStats: true
    });

    const bolaoLinkTab: BaseHeaderListItemViewModel = new BaseHeaderListItemViewModel({
      name: this.terms.WC_2022_NAVIGATION_BAR_BUTTON,
      linkModel: competitionBolaoLinkModel,
      active: false,
      index: 4,
      isBolao: true
    });

    links.push(scoresLinkTab);
    this.isStandingsTabVisible && links.push(standingsLinkTab);
    this.isBracketsTabVisible && links.push(bracketsLinkTab);
    this.isStatsTabVisible && links.push(statsLinkTab);
    this.isBolaoTabVisible && links.push(bolaoLinkTab);

    return links;
  }

  standingsTabTitleName(competition: CompetitionDomainModel): String {
    let standingsTabTitleName = this.terms.STANDINGS;

    if (competition.hasBrackets && this.isSmallView) {
      standingsTabTitleName = this.bracketsName;
    }

    return competition.tableName || standingsTabTitleName
  }

  get isScoresScreenActive(): Boolean {
    const isScoresScreenActive: Boolean = !this.currentLinkModel.params.filter;

    return isScoresScreenActive;
  }

  get isStandingsTabVisible(): Boolean {
    //TODO: this.entity.sportId !== 3 is patch, remove after BE fix
    return (this.entity.hasStandings && this.entity.sportId !== 3);
  }

  get isBracketsTabVisible(): Boolean {
    return this.entity.hasBrackets;
  }


  get isBolaoTabVisible(): Boolean {
    return false;
  }

  get isStatsTabVisible(): Boolean {
    return this.entity.hasStats;
  }

  get isStandingsTabActive(): Boolean {
    const isStandingsFilter: Boolean = this.currentLinkModel.params.filter === COMPETITION_CONTAINER.FILTERS.standings;

    return !this.isBracketsTabActive && isStandingsFilter
  }

  get isBracketsTabActive(): Boolean {
    const isBracketsTabActive: Boolean = this.currentLinkModel.params.filter === COMPETITION_CONTAINER.FILTERS.brackets;

    return isBracketsTabActive
  }

  get isStatsTabActive(): Boolean {
    const isStatsTabActive: Boolean = this.currentLinkModel.params.filter === COMPETITION_CONTAINER.FILTERS.stats;

    return isStatsTabActive
  }

  get bracketsName(): String {
    let bracketsName = this.terms.WEB_BRACKETS;
    if (this.entity?.sport?.id === SPORT_TYPES.tennis) {
      bracketsName = this.terms.WEB_DRAW_INSTEAD_OF_BRACKET;
    }

    return bracketsName;
  }
}
